import React from 'react';
import Grid from '@material-ui/core/Grid';
import { hot } from 'react-hot-loader';

function GridForHeader(props) {
	return (
		<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
			<Grid item sm={8} xs={12}>
				{props.children}
			</Grid>
		</Grid>
	);
}

export default hot(module)(GridForHeader);
